var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder-open-outline-badged",
    transform: "translate(-4 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43918",
    "data-name": "Path 43918",
    d: "M23.816,10.535a1.082,1.082,0,0,0-.917-.469H8.536a1.639,1.639,0,0,0-1.424.963.634.634,0,0,0,0,.089L5.265,17.666V6.267H9.372L11.023,8.54a.633.633,0,0,0,.512.26h5.391a4.744,4.744,0,0,1-.816-1.267H11.858L10.4,5.519A1.265,1.265,0,0,0,9.372,5H5.265A1.266,1.266,0,0,0,4,6.267V20.636a.867.867,0,0,0,.892.83H20.665a.633.633,0,0,0,.633-.456l2.651-9.563a1.039,1.039,0,0,0-.133-.912ZM20.165,20.2H5.835L8.29,11.453a.418.418,0,0,1,.24-.152H22.658Z",
    transform: "translate(0 -1.466)",
    fill: "#0466c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43919",
    "data-name": "Path 43919",
    d: "M31.335,4.168A3.168,3.168,0,1,1,28.168,1a3.168,3.168,0,0,1,3.168,3.168Z",
    transform: "translate(-7.722 0)",
    fill: "#0466c8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.fecaca2b.svg";
export { ForwardRef as ReactComponent };